import { call, put, takeEvery } from "redux-saga/effects";
import { Auth } from "../utilities/auth";
import axios from "../utilities/axiosWrapper";
import { ExtractErrorMessage } from "./utilities/helper";
import { updateBusinessAddressOptions } from "../actions/businessAddress";

// Verifies a single business address against the Canada Post lookup and stores the
// result under its fieldKey. Mirrors the person-address verifyAddressWorker but does
// NOT touch the global loading flag - the per-field `loading` drives the button
// spinner, so validating one address never blocks the rest of the page. takeEvery
// (not takeLatest) so validating a second address never cancels the first.
export function* verifyBusinessAddressWorker(action: any): Generator {
  const { fieldKey, searchString } = action.data;

  yield put(updateBusinessAddressOptions({ fieldKey, loading: true }));

  let apikeys: any = null;
  let jsonResponse: any = null;

  const params: any = {
    method: "POST",
    path: `common/address/suggestions`,
    data: { searchString },
  };

  try {
    apikeys = yield Auth.getAuthTokens();
    jsonResponse = yield call(axios, params, apikeys);
    if (
      !jsonResponse ||
      (jsonResponse &&
        jsonResponse.status !== 200 &&
        jsonResponse.status !== 201)
    ) {
      const errorMsg = ExtractErrorMessage(jsonResponse);
      throw new Error(errorMsg);
    }

    const { data } = jsonResponse?.data;
    if (!data || !data.addressSuggestions || data.addressSuggestions.length === 0) {
      throw new Error("No address found");
    }

    return yield put(
      updateBusinessAddressOptions({
        fieldKey,
        responsePayload: data,
        loading: false,
        hasErrors: false,
        errorPayload: null,
      })
    );
  } catch (error) {
    const errorMessage = ExtractErrorMessage(error);
    yield put(
      updateBusinessAddressOptions({
        fieldKey,
        responsePayload: null,
        loading: false,
        hasErrors: true,
        errorPayload: errorMessage,
      })
    );
    return error;
  }
}

export function* verifyBusinessAddressWatcher(): Generator {
  yield takeEvery("VERIFY_BUSINESS_ADDRESS", verifyBusinessAddressWorker);
}
